\<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            label="인터락번호"
            name="interLockNo"
            v-model="searchParam.interLockNo">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            label="대상설비"
            name="facilityName"
            v-model="searchParam.facilityName">
          </c-text>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-process
            label="관련공정"
            multiple="single"
            name="processCd"
            v-model="searchParam.processCd">
          </c-process>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            type="search"
            label="관리부서"
            name="deptCd"
            :isFirstValue="false"
            v-model="searchParam.deptCd">
          </c-dept>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="interlock"
          title="인터락 작동조건 및 가동중지 범위 목록"
          tableId="interlock"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          rowKey="psiInterLockId"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn v-if="editable" label="등록" icon="add" @btnClicked="equipmentPopup" />
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'inter-lock',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'revisionNum',
            field: 'revisionNum',
            label: 'Rev.',
            align: 'center',
            style: 'width:50px',
            sortable: true,
          },
          {
            name: 'interLockNo',
            field: 'interLockNo',
            label: '인터락 번호',
            align: 'center',
            style: 'width:120px',
            type: 'link',
            sortable: true,
          },
          {
            name: 'facilityName',
            field: 'facilityName',
            label: '대상설비',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            label: '설정값',
            style: 'width:80px',
            align: 'center',
            child: [
              {
                name: 'temperature',
                field: 'temperature',
                label: '온도(℃)',
                align: 'center',
                style: 'width:100px',
                sortable: true,
              },
              {
                name: 'pressure',
                field: 'pressure',
                label: '압력(Mpa)',
                align: 'center',
                style: 'width:100px',
                sortable: true,
              },
              {
                name: 'liquidLevel',
                field: 'liquidLevel',
                label: '액위(m)',
                align: 'center',
                style: 'width:100px',
                sortable: true,
              },
              {
                name: 'etc',
                field: 'etc',
                label: '기타',
                align: 'center',
                style: 'width:100px',
                sortable: true,
              },
            ]
          },
          {
            name: 'detectorNum',
            field: 'detectorNum',
            label: '감지기번호',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'lastOperationEquipment',
            field: 'lastOperationEquipment',
            label: '최종작동설비',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'operationStopRange',
            field: 'operationStopRange',
            label: '가동중지범위',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'checkCycle',
            field: 'checkCycle',
            label: '점검주기',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'remark',
            field: 'remark',
            label: '비고',
            align: 'center',
            style: 'width:200px',
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: '',
        interLockNo: '',
        facilityName: '',
        processCd: '',
        deptCd: '',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.psi.pcd.interlock.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.equipmentPopup(row);
    },
    equipmentPopup(result) {
      this.popupOptions.target = () => import(`${"./interlockOperationDetail.vue"}`);
      this.popupOptions.title = '인터락 작동조건및 가동중지 범위 상세';
      this.popupOptions.param = {
        psiInterLockId: result ? result.psiInterLockId : '',
      };
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
